import { Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

const Address = ({
    practiceAddress: address,
    practiceCity: city,
    practiceStateProvince: state,
    postalCode: zip,
}) => {
    let stateZip = `${state} ${zip}`;

    const addressArray = [address, city, stateZip].filter(Boolean);

    const addressLink =
        'https://maps.google.com/maps?q=' +
        addressArray.join(' ').replaceAll(' ', '+');

    const addressDisplay = addressArray.join(', ');

    return (
        <Col lg={6} className="py-3 d-flex px-3 py-2" title="Practice Address">
            <FontAwesomeIcon
                className="text-light op-6"
                icon={faMapMarkerAlt}
                size="lg"
            />
            &emsp;
            {city && state ? (
                <a
                    className="sc-a-link"
                    target="_blank"
                    rel="noreferrer"
                    href={addressLink}>
                    {addressDisplay}
                </a>
            ) : (
                '--'
            )}
        </Col>
    );
};

export default Address;
